import InPageSearchCheckBoxGroup from './InPageSearchCheckBoxGroup';

export default InPageSearchCheckBoxGroup;
